// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".repair-box-item{margin-top:15px}@media only screen and (max-width:600px){.repair-box-item{padding-right:5px;padding-left:5px}.repair-box-item--cat{padding:0 40px}}.repair-box-item img{border-radius:15px;width:100%}.repair-box-item a{display:block}.repair-box-item__title{text-align:center;display:block;padding:5px 0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);
// Exports
module.exports = exports;
